import { Heading, Text, Box, Flex, Divider } from '@televet/kibble-ui';
import React from 'react';
import { ClinicAvatar } from 'shared/components/Avatars';
import { useAuth } from 'shared/providers/AuthProvider';
import useClinicUser from 'shared/hooks/useClinicUser';
import { useSnoozeProvider } from 'shared/providers/SnoozeProvider';
import { MenuTitle } from '.';
import MobileMenuItem from './MobileMenuItem';
import { useMobileMenuProvider, MobileMenuViews } from './MobileMenuProvider';

const MobileMenuRootView = (): JSX.Element => {
  const { logout } = useAuth();
  const { clinicUser, currentClinic } = useClinicUser();
  const { setCurrentMobileMenuView } = useMobileMenuProvider();
  const { isSnoozed } = useSnoozeProvider();

  return (
    <>
      <MenuTitle>
        <Heading px={5} size="lg">
          {MobileMenuViews.Root}
        </Heading>
      </MenuTitle>
      {currentClinic && (
        <Box py={3}>
          <CurrentActiveUser>
            <ClinicAvatar isClinic size="lg" />
            <Text size="lg" fontWeight="bold" ml={3}>
              {currentClinic.name}
            </Text>
          </CurrentActiveUser>
          {currentClinic?.submerchantStripeId && currentClinic?.submerchantStripeChargesEnabled && (
            <MobileMenuItem
              onClick={(): void => setCurrentMobileMenuView(MobileMenuViews.SendInvoice)}
              text="Send Payment"
            />
          )}
          <MobileMenuItem
            onClick={(): void => setCurrentMobileMenuView(MobileMenuViews.ChangeClinics)}
            text="Change Clinic"
          />
        </Box>
      )}
      <Divider mb={1} />
      <Box py={3}>
        {clinicUser && (
          <CurrentActiveUser>
            <ClinicAvatar clinicMember={clinicUser} showTooltip={false} size="lg" />
            <Flex flexDirection={'column'} pl={3}>
              <Text size="lg" fontWeight="bold">
                {[clinicUser.firstName, clinicUser.lastName || ''].join(' ')}
              </Text>
              <Text size="sm">{isSnoozed ? 'Inactive' : 'Active'}</Text>
            </Flex>
          </CurrentActiveUser>
        )}
        <MobileMenuItem
          onClick={(): void => setCurrentMobileMenuView(MobileMenuViews.SnoozeNotifications)}
          text="Snooze notifications"
        />
        <MobileMenuItem
          data-mixpanel-name="mobile navbar profile get help button"
          data-testid="mobile-navbar-get-help-button"
          onClick={(): void => {
            if (window.zE) {
              window.zE('messenger', 'open');
            }
            return;
          }}
          text="Help"
        />
        <MobileMenuItem
          hasIcon={false}
          onClick={(): void => {
            logout();
          }}
          text="Logout"
        />
      </Box>
    </>
  );
};

const CurrentActiveUser = ({ children }: { children: React.ReactNode }): JSX.Element => {
  return (
    <Flex h="60px" px={5} py={3} justify="flex-start" align="center">
      {children}
    </Flex>
  );
};

export default MobileMenuRootView;
